module.exports = __webpack_public_path__ + "img/replay-chard.bdf8b9a6.svg";